<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 32"
    class="icon-svg icon-amex"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1512 -906) translate(1176 140) translate(0 614) translate(0 152) translate(336)"
      >
        <rect
          width="47"
          height="31"
          x=".5"
          y=".5"
          stroke="#d5d5d5"
          fill="#FFFFFF"
          rx="4"
        />
        <path
          fill="#006AD1"
          fill-rule="nonzero"
          d="M13.466 14.363l.85 1.954h-1.695l.845-1.954zm17.675.08h-3.274v.862h3.22v1.29h-3.213v.961h3.273v.77l2.284-2.338-2.284-2.438-.006.894zm-15.463-2.437h4.393l.975 2.016L21.95 12h11.402l1.185 1.24L35.763 12H41l-3.87 4.012L40.96 20h-5.315l-1.185-1.24L33.223 20H14.63l-.543-1.24h-1.242L12.3 20H8l3.613-8h3.771l.294.006zm9.525 1.123h-2.462l-1.649 3.684-1.787-3.684h-2.443v5.01l-2.265-5.01h-2.191l-2.62 5.742h1.71l.544-1.24h2.854l.543 1.24h2.99v-4.1l1.926 4.106h1.309l1.913-4.093v4.094h1.603l.026-5.75v.001zm10.27 2.883l2.783-2.883h-2.004l-1.76 1.798-1.702-1.798h-6.48v5.748h6.387l1.775-1.81 1.702 1.81h2.062l-2.762-2.864h-.001z"
        />
      </g>
    </g>
  </svg>
</template>
